import { useContext } from 'react'

import { Grid, Stack } from '@mui/material'

import { CardTitle, FplDynamicTabs, TabPanelBootstrap } from 'components/common'

import { ReadOnlyBookingAddressType } from '.'
import { AddressContext } from './AddressProvider'
import { ReadOnlyBookingAddress } from './ReadOnlyBookingAddress'

interface ISupplierDeliveryAddress {
  addresses: ReadOnlyBookingAddressType[]
}

export const SupplierDeliveryAddress = ({ addresses }: ISupplierDeliveryAddress) => {
  const { deliveryTabValue, setDeliveryTabValue } = useContext(AddressContext)

  const handleTabChange = (_, newValue) => {
    setDeliveryTabValue(newValue)
  }

  return (
    <Stack spacing={1.5}>
      <Grid container columnSpacing={1.5} justifyContent='space-between'>
        <Grid item>
          <CardTitle marginBottom={0}>Delivery</CardTitle>
        </Grid>
      </Grid>

      <Stack>
        <FplDynamicTabs
          tabValue={deliveryTabValue}
          fields={addresses}
          name='delivery-address'
          onTabChange={handleTabChange}
          label={'ADD'}
          showRemoveButton={false}
          showAddButton={false}
          disabled={true}
          onAddClick={undefined}
        />

        {addresses.map((item, index) => (
          <TabPanelBootstrap value={deliveryTabValue} index={index} key={item.tabsKey}>
            <ReadOnlyBookingAddress
              address={item}
              key={item.tabsKey}
              labelAt='Deliver From'
              labelBy='Deliver By'
            />
          </TabPanelBootstrap>
        ))}
      </Stack>
    </Stack>
  )
}
